import api from '@/api';
import { API_BASE_URL } from '../../index';
import { WorkOrderMigrationRequest } from './work-order-migration-consult.types';

const CONTROLLER_URL = `${API_BASE_URL}/generate`;

export async function getWorkOrderMigration(params: WorkOrderMigrationRequest) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/work-order-migration`,
    params,
  )) as unknown;

  return result as BlobPart;
}
